import { render, staticRenderFns } from "./ManageFacebook.vue?vue&type=template&id=0fe962a8&scoped=true&"
import script from "./ManageFacebook.vue?vue&type=script&lang=ts&"
export * from "./ManageFacebook.vue?vue&type=script&lang=ts&"
import style0 from "./ManageFacebook.vue?vue&type=style&index=0&id=0fe962a8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe962a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardActions,VCardText,VCardTitle,VCol,VContainer,VIcon,VRow,VSpacer,VTooltip})
